import Scannerfile from "../../assets/img/scannerfile.gif";
import useTranslator from "../../hooks/useTranslator";
const DocumentAnalysisLoadingPopup = ({ showPopup, isGuarantor }) => {
  const { _t } = useTranslator();
  return (
    <>
      {showPopup && (
        <div
          className={`approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 modal-fixed-screen flex items-center justify-center z-50 wrapper-modal ${isGuarantor ? "guarantorBg" : ""}`}
        >
          <div className="popup-content2 popup-content bg-white required-doc-popup doc-analysis-modal">
            <div className="row">
              <div className="col-12 scanningDoc">
                <div className="custom-mb-4">
                  <div className="upload-messages">
                    <h4>
                      {_t(
                        "weKeepYourDataSecureAndProtected",
                        "Text used in onboarding flow while document is being sent for analysis"
                      )}
                    </h4>
                    <h4>
                      {_t(
                        "yourPrivacyIsAlwaysOurPriority",
                        "Text used in onboarding flow while document is being sent for analysis"
                      )}
                    </h4>
                    <h4>
                      {_t(
                        "trustedProtection,EveryStepOfTheWay",
                        "Text used in onboarding flow while document is being sent for analysis"
                      )}
                    </h4>
                  </div>
                  <div className="upload-messages position-relative">
                    <p>
                      {" "}
                      {_t(
                        "analysingTheDocuments",
                        "Text used in onboarding flow while document is being sent for analysis"
                      )}
                    </p>
                    <p>
                      {_t(
                        "holdTightYourFilesAreOnTheirWay",
                        "Text used in onboarding flow while document is being sent for analysis"
                      )}
                    </p>
                    <p>
                      {_t(
                        "workingOnItUploadInProgress",
                        "Text used in onboarding flow while document is being sent for analysis"
                      )}
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <img className="scanImageGif" src={Scannerfile} alt="img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DocumentAnalysisLoadingPopup;
